export class Message
{
    constructor(
        public Name: string,
        public Body?: any) { }
}
